var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-card border-0"},[_c('div',{staticClass:"z-card__body"},[_c('column-chart',{attrs:{"type":"BarChart","data":_vm.chart_data,"options":_vm.chart_options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }